module.exports = "/images/ny-life2-9.jpg";